import React from 'react';
import PropTypes from 'prop-types';

const ProfileModal = ({ isOpen, onClose, title, children, loading, error, success }) => {
  if (!isOpen) return null;

  return (
    <div className="profile-modal-overlay" onClick={onClose}>
      <div className="profile-modal-content" onClick={e => e.stopPropagation()}>
        <div className="profile-modal-header">
          <h2>{title}</h2>
          <button className="profile-close-btn" onClick={onClose}>×</button>
        </div>
        
        {loading && <div className="profile-loading">Loading...</div>}
        {error && <div className="profile-error-message">{error}</div>}
        {success && <div className="profile-success-message">{success}</div>}
        
        {children}
      </div>
    </div>
  );
};

ProfileModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.string,
  success: PropTypes.string
};

export default ProfileModal;